module.exports = __webpack_public_path__ + "img/link.88da3aac.svg";